import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Home.css";
import { FaPhoneVolume } from "react-icons/fa6";
import { Link } from "react-router-dom";
import BookingFormModal from "../common/BookingFormModal";
const Hero = () => {
   const [active, setActive] = useState(false);
      const [serviceActive, setServiceActive] = useState(false);
    
      const [activeModal, setActiveModal] = useState(false);
      const [activeClass, setActiveClass] = useState(0);
    
      const [isOpen, setIsOpen] = useState(false);
      const [isSticky, setIsSticky] = useState(false);
      // const [active, setIsActive] = useState(false);
    
      const handleMenuClick = () => {
        setIsOpen(!isOpen);
        setActive(!active);
      };
    
      // const handleScroll = () => {
      //   setIsSticky(window.scrollY > 40);
      // };
    
      // useEffect(() => {
      //   window.addEventListener("scroll", handleScroll);
      //   return () => {
      //     window.removeEventListener("scroll", handleScroll);
      //   };
      // }, []);
      const [showModal, setShowModal] = useState(false);
    
      const handleOpenModal = () => setShowModal(true);
      const handleCloseModal = () => setShowModal(false);
      const handleBookAppointments = () => {
        setActiveModal(!activeModal);
      };
      const handleBookAppointment = () => {
        setActiveModal(!activeModal);
        setActive(false);
      };
  return (
    <div className="hero-container-background">
      <div
        className="overlay overlay-bold"
        style={{ background: "#0000009e" }}
      ></div>
      <Container style={{ position: "relative", zIndex: "10" }}>
        <Row>
          <Col>
            <div className="herosection-inner-divss">
              <div>
                {/* <h4 className="herosection-headingfour">Surgery Saathi</h4> */}
                <h1 className="heroSection-headingOnee">
                  Your Journey to a More Confident <span> You Starts Here</span>
                </h1>
              </div>
              <div
                style={{ width: "100%" }}
                className="herosection-inner-sec-div"
              >
                <p className="heroSection-paraa">
                  Surgery Saathi offers safe and professional cosmetic surgery
                  to help you look your best. Our experienced doctors are
                  dedicated to giving you great results with the care you
                  deserve.
                </p>
              </div>
              <div className="phone-number-hero-secrionss">
                <Link
                  style={{ color: "#fff" }}
                  className="link-phone-calllss"
                  to="tel:+918882852726"
                >
                  <FaPhoneVolume />
                  +918882852726
                </Link>

                <button
                  className="hero-container-appointement"
                  style={{ color: "#fff" }}
                  onClick={handleBookAppointments}
                >
                  Schedule Your Consultation Today!
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {activeModal ? (
        <BookingFormModal active={activeModal} setActive={setActiveModal} />
      ) : (
        ""
      )}
    </div>
  );
};

export default Hero;
